module.exports = __webpack_public_path__ + "img/Wagon_Front_Side_Left_Transparent.81411bab.svg";